import { ResultOf } from 'gql.tada';
import { gql } from '../../gql';

export const GET_MAKE_IDS = gql(`
  query GetMakeIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblyMakes(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`);

export const GET_MAKES = gql(`
  query GetMakes(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblyMakes(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      visible
    }
  }
`);

export type MakeItem = ResultOf<
  typeof GET_MAKES
>['backflowAssemblyMakes'][number];
